export default __webpack_public_path__ + "static/media/demo.eba6dcb8.mp4";